export default __webpack_public_path__ + "static/media/NotFoundSheet.2ef8421f.png";